export const preloadedValues = {
  bcosRecStatus: false,
  bcosCodigoFebraban: "",
  bcosCodigoFebrabanDV: "",
  bcosNomeFebraban: "",
  bcosNome: "",
  bcCtBanco:[]

};
